import { useParams as useNextParams } from 'next/navigation';
import { parseParams } from 'project.config';

const useSlug = (): string | undefined => {
  const params = useNextParams();
  parseParams(params);
  const { slug } = params;
  return Array.isArray(slug) ? slug.join('_') : slug;
};

export default useSlug;
